var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg54555",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    sodipodiDocname: "emu.svg",
    inkscapeVersion: "1.2.2 (732a01da63, 2022-12-09)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs54559"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview54557",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "true",
    inkscapeZoom: 22.797123,
    inkscapeCx: 26.626167,
    inkscapeCy: 16.800366,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1009,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g54561"
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid123153"
  }))), /*#__PURE__*/React.createElement("g", {
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Image",
    id: "g54561"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123155",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123157",
    width: 0.99999982,
    height: 1,
    x: 8,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123159",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123161",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123163",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123165",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123167",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123169",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123171",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123173",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123175",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123177",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123179",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123181",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123183",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123185",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123187",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123189",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123191",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123193",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123195",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123197",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123199",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123201",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123203",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123205",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123207",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123209",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123211",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123213",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123215",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123217",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123219",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123221",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123223",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123225",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123227",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123229",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123231",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123233",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123235",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123237",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123239",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123241",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123243",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123245",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123247",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123249",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123251",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123253",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123255",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123257",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123259",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123261",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123263",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123265",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123267",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123269",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123271",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123273",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123275",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123277",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123279",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123281",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123283",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123285",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123287",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123289",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123291",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123293",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123295",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123297",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123299",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123301",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123303",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123305",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123307",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123309",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123311",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123313",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123315",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123317",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123319",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123321",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123323",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123325",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123327",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123329",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123331",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123333",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123335",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123337",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123339",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123341",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123343",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123345",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123347",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123349",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123351",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123353",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123355",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123357",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123359",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123361",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123363",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123365",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123367",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123369",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123371",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123373",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123375",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123377",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123379",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123381",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123383",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123385",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123387",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123389",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123391",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123393",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123395",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123397",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123399",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123401",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123403",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123405",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123407",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123409",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123411",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123413",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123415",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123417",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123419",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123421",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123423",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123425",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123427",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123429",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123431",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123433",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123435",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123437",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123439",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123441",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123443",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123445",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123447",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123449",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123451",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123453",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123455",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123457",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123459",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123461",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123463",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123465",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123467",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123469",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123471",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123473",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123475",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123477",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123479",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123481",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123483",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123485",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123487",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123489",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123491",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123493",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123495",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123497",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 28,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123499",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 29,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123501",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 29,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123503",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 28,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123505",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 29,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123507",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 29,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123509",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 29,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123511",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 28,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123513",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 28,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123515",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 27,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123517",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 28,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123519",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 26,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123521",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 26,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123523",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 27,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123525",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 25,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123527",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 26,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123529",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 27,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123531",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 28,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123533",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 28,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123535",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 29,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123537",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 28,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123539",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 27,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123541",
    width: 0.99999982,
    height: 1,
    x: 40,
    y: 27,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123543",
    width: 0.99999982,
    height: 1,
    x: 40,
    y: 26,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123545",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 26,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123547",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 26,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123549",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 25,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123551",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 25,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123553",
    width: 0.99999982,
    height: 1,
    x: 40,
    y: 25,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123555",
    width: 0.99999982,
    height: 1,
    x: 40,
    y: 24,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123557",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 24,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123559",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 24,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123563",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 24,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123565",
    width: 0.99999982,
    height: 1,
    x: 40,
    y: 24,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123567",
    width: 0.99999982,
    height: 1,
    x: 40,
    y: 23,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123569",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 23,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123571",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 22,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123573",
    width: 0.99999982,
    height: 1,
    x: 40,
    y: 22,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123575",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 21,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123577",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 20,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123579",
    width: 0.99999982,
    height: 1,
    x: 39,
    y: 19,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123581",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 18,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123583",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 17,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123585",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 16,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123587",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 15,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123589",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 14,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123591",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 13,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123593",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 12,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123595",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 11,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123597",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 11,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123599",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 10,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123601",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 10,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123603",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 10,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658
    },
    id: "rect123605",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 10,
    "inkscapeTransform-center-x": -0.10856079,
    "inkscapeTransform-center-y": 0.015508685
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 1.0658,
      opacity: 0.5
    },
    id: "rect123607",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124089",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124091",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124093",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124095",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124097",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124099",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124101",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124103",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124105",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124107",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124109",
    width: 0.99999982,
    height: 1,
    x: 8,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124111",
    width: 0.99999982,
    height: 1,
    x: 7,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124113",
    width: 0.99999982,
    height: 1,
    x: 7,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124115",
    width: 0.99999982,
    height: 1,
    x: 8,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124117",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124119",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124121",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124123",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124125",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124127",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124129",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124131",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124133",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124135",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124137",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124139",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124141",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124143",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124145",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124147",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124149",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124151",
    width: 0.99999982,
    height: 1,
    x: 8,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124153",
    width: 0.99999982,
    height: 1,
    x: 7,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124155",
    width: 0.99999982,
    height: 1,
    x: 7,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124157",
    width: 0.99999982,
    height: 1,
    x: 8,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124159",
    width: 0.99999982,
    height: 1,
    x: 8,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124161",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124163",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124165",
    width: 0.99999982,
    height: 1,
    x: 9,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124167",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124169",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124171",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124173",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124175",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124177",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124179",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124181",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124183",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124185",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124187",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124189",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124191",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124193",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124195",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124197",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124199",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124201",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124203",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124205",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124207",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124209",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124211",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124213",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124215",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124217",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124219",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124221",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124223",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124225",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124227",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124229",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124231",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124233",
    width: 0.99999982,
    height: 1,
    x: 11,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124235",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124237",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124239",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124241",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124243",
    width: 0.99999982,
    height: 1,
    x: 10,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124245",
    width: 0.99999982,
    height: 1,
    x: 12,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124247",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124249",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124251",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124253",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124255",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124257",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124259",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124261",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124263",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124265",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124267",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124269",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124271",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124273",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124275",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124277",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124279",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124281",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124283",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124285",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124287",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124289",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124291",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124293",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124295",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124297",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124299",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124301",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124303",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124305",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124307",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124309",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124311",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124313",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124315",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124317",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124319",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124321",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124323",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124325",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124327",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124329",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124331",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124333",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124335",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124337",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124339",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124341",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124343",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124345",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124347",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124349",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124351",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124353",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124355",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124357",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124359",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124361",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124363",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124365",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124367",
    width: 0.99999982,
    height: 1,
    x: 13,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124369",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124371",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124373",
    width: 0.99999982,
    height: 1,
    x: 14,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124375",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124377",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124379",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124381",
    width: 0.99999982,
    height: 1,
    x: 15,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124383",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124385",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124387",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124389",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124391",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124393",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124395",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124397",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124399",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124401",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124403",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124405",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124407",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124409",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124411",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124413",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124415",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124417",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124419",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124421",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124423",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.50727
    },
    id: "rect124425",
    width: 2,
    height: 1,
    x: 28,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.50727
    },
    id: "rect124427",
    width: 2,
    height: 1,
    x: 30,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124429",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124431",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124433",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124435",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124437",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124439",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124441",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124443",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124445",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124447",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124449",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124451",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124453",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124455",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124457",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124459",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124461",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124463",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124465",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124467",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124469",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124471",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124473",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124475",
    width: 0.99999982,
    height: 1,
    x: 38,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124477",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124479",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124481",
    width: 0.99999982,
    height: 1,
    x: 37,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124483",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124485",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124487",
    width: 0.99999982,
    height: 1,
    x: 41,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124489",
    width: 0.99999982,
    height: 1,
    x: 41,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124491",
    width: 0.99999982,
    height: 1,
    x: 41,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124493",
    width: 0.99999982,
    height: 1,
    x: 41,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124495",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124497",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124499",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124501",
    width: 0.99999982,
    height: 1,
    x: 36,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124503",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124505",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124507",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124509",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124511",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124513",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124515",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124517",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124519",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124521",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124523",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124525",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124527",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124529",
    width: 0.99999982,
    height: 1,
    x: 35,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124531",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124533",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124535",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124537",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124539",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124541",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124543",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124545",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124547",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124549",
    width: 0.99999982,
    height: 1,
    x: 34,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124551",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124553",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124555",
    width: 0.99999982,
    height: 1,
    x: 33,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124557",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124559",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124561",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124563",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124565",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124567",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124569",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124571",
    width: 0.99999982,
    height: 1,
    x: 32,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124573",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124575",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124577",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124579",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124581",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124583",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124585",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124587",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124589",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124591",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124593",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124595",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124597",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124599",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124601",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124603",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124605",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124607",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124609",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124611",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124613",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124615",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124617",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124619",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124621",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124623",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124625",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124627",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124629",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124631",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124633",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124635",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124637",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124639",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124641",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124643",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124645",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124647",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124649",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124651",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124653",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124655",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124657",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124659",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124661",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124663",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124665",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124667",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124669",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124671",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124673",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124675",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124677",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124679",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124681",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124683",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124685",
    width: 0.99999982,
    height: 1,
    x: 16,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124687",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124689",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124691",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124693",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124695",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124697",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124699",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124701",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124703",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124705",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124707",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124709",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124711",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124713",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124715",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124717",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124719",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124721",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124723",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124725",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124727",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124729",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124731",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124733",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124735",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124737",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124739",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124741",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124743",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124745",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124747",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124749",
    width: 0.99999982,
    height: 1,
    x: 31,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124751",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124753",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124755",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124757",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124759",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124761",
    width: 0.99999982,
    height: 1,
    x: 30,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124763",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124765",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124767",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect124769",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125974",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125976",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125978",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.50727
    },
    id: "rect125980",
    width: 1.9999998,
    height: 1,
    x: 23,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125982",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125984",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125986",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125988",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125990",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125992",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125994",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125996",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect125998",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126000",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126002",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126004",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126006",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126008",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126010",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126012",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126014",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126016",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126018",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126020",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126022",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126024",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126026",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126028",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126030",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126032",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126034",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126036",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126038",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126040",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126042",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126044",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126046",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126048",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126050",
    width: 0.99999982,
    height: 1,
    x: 29,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126052",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126054",
    width: 0.99999982,
    height: 1,
    x: 28,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126056",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126058",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126060",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126062",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126064",
    width: 0.99999982,
    height: 1,
    x: 26,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126066",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126068",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126070",
    width: 0.99999982,
    height: 1,
    x: 25,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126072",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126074",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126076",
    width: 0.99999982,
    height: 1,
    x: 24,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126078",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126080",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126082",
    width: 0.99999982,
    height: 1,
    x: 23,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126084",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126086",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126088",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126090",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126092",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126094",
    width: 0.99999982,
    height: 1,
    x: 17,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126096",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126098",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126100",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126102",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126104",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126106",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126108",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126110",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126112",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126114",
    width: 0.99999982,
    height: 1,
    x: 18,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126116",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126118",
    width: 0.99999982,
    height: 1,
    x: 19,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126120",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126122",
    width: 0.99999982,
    height: 1,
    x: 20,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126124",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126126",
    width: 0.99999982,
    height: 1,
    x: 21,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126128",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect126130",
    width: 0.99999982,
    height: 1,
    x: 22,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 1.0658
    },
    id: "rect128796",
    width: 0.99999982,
    height: 1,
    x: 27,
    y: 17
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmu);
export default __webpack_public_path__ + "static/media/emu.3a27325bc6b44b8eda398d6fad8e1a6c.svg";
export { ForwardRef as ReactComponent };